<template>
  <header class="toolp_nav">
    <div>
      <ul class="toolp_nav__menu">
        <li class="toolp_nav__item">
          <div class="toolp_nav__logo">
            <h4 style="    margin-left: 13px;
    margin-top: 2px;">
              "{{ agentName }}" has cancelled access to this account. You no longer have access to the Users page or App
              Display Information page. Please contact the agent owner by email to inquire further.
            </h4>
          </div>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
  import PaymentMixin from '@/mixins/payment';
  import {mapState} from "vuex";

  export default {
    name: "NavPaymentBanner",
    mixins: [PaymentMixin],
    computed: {
      ...mapState({
        user: state => state.Authenticate.user
      }),
      agentName() {
        return this.user ? this.user.tenants_list.find(x => x.tenant_id === this.user.tenant_id).company_name : "";
      }
    }
  };
</script>
